import { useEffect, useState } from "react";
import { LogOut, User } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { supabase } from "../../../../lib/supabase";
import { Logo } from "../Logo";

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const getUser = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (user?.email && location.pathname !== "/auth/login") {
        setUserEmail(user.email);
      } else {
        setUserEmail(null);
      }
    };
    getUser();

    const { data: authListener } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_OUT") {
        setUserEmail(null);
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [location.pathname]);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setUserEmail(null);
    navigate("/auth/login");
  };

  return (
    <header className="w-full border-b">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <div className="flex items-center gap-8">
          <Logo />
        </div>
        {userEmail && (
          <div className="relative">
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="flex items-center gap-2 text-gray-700 hover:text-gray-900"
            >
              <div className="flex size-8 items-center justify-center rounded-full bg-[#4CAF50]">
                <User className="size-4 text-white" />
              </div>
              <span className="hidden sm:inline">{userEmail}</span>
            </button>

            {showMenu && (
              <div className="absolute right-0 mt-2 w-48 rounded-lg border bg-white py-1 shadow-lg">
                <button
                  onClick={handleSignOut}
                  className="flex w-full items-center gap-2 px-4 py-2 text-left text-gray-700 hover:bg-gray-50"
                >
                  <LogOut className="size-4" />
                  Sign Out
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
